import React from "react";
import Navbar from "../components/Navbar";
import "../styles/global.css";
import Blogs from "../components/Blogs";
import Footer from "../components/Footer";

const BlogsPage = () => {
  return (
    <>
      <header className="navbar">
        <Navbar />
      </header>

      <div >
        <section className="blogs">
          <Blogs />
        </section>
        
      </div>

      <footer className="footer">
        <Footer />
      </footer>
      
    </>
  );
};

export default BlogsPage;
